import axios from 'axios';
import { tokenUtils } from '../utils/tokenUtils';

const API_URL = process.env.REACT_APP_API_URL + '/Document';

function getAuthHeaders() {
  const token = tokenUtils.get();
  if (!token) throw new Error('No se encontró token de autenticación');
  return {
    Authorization: `Bearer ${token}`,
  };
}

axios.interceptors.response.use(
  response => response,
  error => {
    if (error.response?.status === 401) {
      tokenUtils.clearAuth();
      window.location.href = '/';
    }
    return Promise.reject(error);
  }
);

const getDocuments = async () => {
  try {
    const response = await axios.get(API_URL, {
      headers: getAuthHeaders(),
    });
    return response.data;
  } catch (error) {
    console.error('Error al obtener documentos:', error);
    throw error;
  }
};

const getDocumentById = async (id) => {
  try {
    const response = await axios.get(`${API_URL}/${id}`, {
      headers: getAuthHeaders(),
    });
    return response.data;
  } catch (error) {
    console.error('Error al obtener documento por ID:', error);
    throw error;
  }
};

const updateDocument = async (id, documentData) => {
  try {
    // Determinar si es FormData o JSON
    const isFormData = documentData instanceof FormData;
    
    const headers = getAuthHeaders();
    if (!isFormData) {
      headers['Content-Type'] = 'application/json';
    }
    
    const response = await axios.put(`${API_URL}/${id}`, documentData, {
      headers: headers,
    });
    return response.data;
  } catch (error) {
    console.error('Error al actualizar documento:', error);
    throw error;
  }
};

const deleteDocument = async (id) => {
  try {
    await axios.delete(`${API_URL}/${id}`, {
      headers: getAuthHeaders(),
    });
  } catch (error) {
    console.error('Error al eliminar documento:', error);
    throw error;
  }
};

const documentsService = {
  getDocuments,
  getDocumentById,
  updateDocument,
  deleteDocument
};

export default documentsService;
